<template>
    <div>
        
        <v-card class="mt-n1 pa-6" style="border:6px solid #EBEBEB">
            <!-- <Pocket title="HEADLINE" icon="fa-heart" :content="item.headline" v-if="item.headline" /> -->
            <div class="primary--text caption font-weight-medium">HEADLINE</div>
            <div class="headline" v-html="item.headline" v-if="item.headline"></div>
            <Pocket class="mt-6" title="LOCATION" icon="fa-map-marker" :content="item.location" v-if="item.location" />
            <Pocket class="mt-6" title="CONTACT INFO" icon="fa-id-card-alt" :content="item.contactInfo" v-if="item.contactInfo" />
            <Pocket class="mt-6" title="PROVIDING SERVICES" icon="fa-box-open" :content="item.providingServices" v-if="item.providingServices" />
        </v-card>

        <v-card class="mt-10" style="border:6px solid #EBEBEB">
            <div class="pa-6 cyan d-flex justify-space-between">
                <div class="white--text headline">ABOUT</div>
                <v-icon small color="cyan darken-3">fa-plane-departure</v-icon>
            </div>
            <div class="pa-6">
                <Pocket title="ABOUT" icon="fa-smile" :content="item.about" v-if="item.about" />
                <Pocket class="mt-6" title="SKILLS & ENDORSMENTS" icon="fa-chart-pie" :content="item.skills" v-if="item.skills" />
                <Pocket class="mt-6" title="ACTIVITY" icon="fa-chart-line" :content="item.activity" v-if="item.activity" />
                <Pocket class="mt-6" title="INTERESTS" icon="fa-book" :content="item.interests" v-if="item.interests" />
                <Pocket class="mt-6" title="LANGUAGES" icon="fa-globe" :content="item.languages" v-if="item.languages" />
            </div>
        </v-card>

        <v-card class="mt-10" style="border:6px solid #EBEBEB">
            <div class="pa-6 cyan d-flex justify-space-between">
                <div class="white--text headline">BACKGROUND</div>
                <v-icon small color="cyan darken-3">fa-plane-departure</v-icon>
            </div>
            <div class="pa-6">
                <Pocket title="EXPERIENCE" icon="fa-briefcase" :content="item.experience" v-if="item.experience" />
                <Pocket class="mt-6" title="VOLUNTEER EXPERIENCE" icon="fa-hands-helping" :content="item.volunteerExperience" v-if="item.volunteerExperience" />
                <Pocket class="mt-6" title="EDUCATION" icon="fa-book" :content="item.education" v-if="item.education" />
                <Pocket class="mt-6" title="ORGANIZATIONS & CLUBS" icon="fa-store" :content="item.organizations" v-if="item.organizations" />
                <Pocket class="mt-6" title="PUBLICATIONS" icon="fa-book-reader" :content="item.publications" v-if="item.publications" />
            </div>
        </v-card>

        <v-card class="mt-10" style="border:6px solid #EBEBEB">
            <div class="pa-6 cyan d-flex justify-space-between">
                <div class="white--text headline">ACCOMPLISHMENTS</div>
                <v-icon small color="cyan darken-3">fa-plane-departure</v-icon>
            </div>
            <div class="pa-6">
                <Pocket title="COURSES" icon="fa-clipboard" :content="item.courses" v-if="item.courses" />
                <Pocket class="mt-6" title="PROJECTS" icon="fa-dna" :content="item.projects" v-if="item.projects" />
                <Pocket class="mt-6" title="HONORS & AWARDS" icon="fa-award" :content="item.honors" v-if="item.honors" />
            </div>
        </v-card>
    </div>
</template>

<script>
import Pocket from '@/components/planner/Pocket'
export default {
    props: ['item', 'top'],
    components: {
        Pocket
    }
}
</script>